<div class="doughnut-chart">
    <canvas #doughnutChart></canvas>
</div>
